import $ from 'jquery'

async function init () {
  $('form[name="contact-teaser"]').each(async function () {
    await import(/* webpackChunkName: "jquery-validation" */ 'jquery-validation')
    handleContactTeaserFormSubmit($(this))
  })
}

function handleContactTeaserFormSubmit (element) {
  let contactTeaserForm = element

  $.validator.setDefaults({
    debug: false,
    success: 'valid',
    messages: {
      Company: {
        required: window.formErrors.default,
        maxlength: window.formErrors.inputMaxLength100
      },
      Email: {
        required: window.formErrors.default,
        email: window.formErrors.email,
        maxlength: window.formErrors.inputMaxLength100
      }
    }
  })

  let $contactTeaserForm = contactTeaserForm.validate({
    ignore: [],
    focusInvalid: false,
    onkeyup: function (element, event) {
      if ($(element).attr('name') != 'Email') {
        $(element).valid()
      }
    },
    onfocusout: function (element) {
      $(element).valid()
    },
    rules: {
      Email: {
        maxlength: 100,
        required: true
      },
      Company: {
        maxlength: 100,
        required: true
      },
    },
    errorPlacement: function (error, $element) {
      error.insertAfter($element)
    },
    invalidHandler: function (form, validator) {
      if (!validator.numberOfInvalids()) {
        return
      }

      // 50px for better look
      let headerHeight = $('header').height() + 50

      $('html, body').animate({
        scrollTop: ($(validator.errorList[0].element).offset().top - headerHeight)
      }, 1000)
    },
    submitHandler: function () {
      let $submitButton = contactTeaserForm.find('[type=submit]')
      $submitButton.prop('disabled', true).css('cursor', 'wait')
      document.body.style.cursor = 'wait'

      if (contactTeaserForm.attr('action').split('?')[1] != undefined) {
        window.location.href = contactTeaserForm.attr('action').split('?')[0] + '?contactTeaserData=' + btoa(contactTeaserForm.attr('action').split('?')[1] + '&' + contactTeaserForm.serialize())
      } else {
        window.location.href = contactTeaserForm.attr('action').split('?')[0] + '?contactTeaserData=' + btoa(contactTeaserForm.serialize())
      }
    }
  })

}

export default {
  init
}
